import React from "react";
import { ResetPassword } from "../containers";

const ResetPasswordPage = props => {
  return <ResetPassword token={props.match.params.id} />;
};

export default ResetPasswordPage;
